<template>
    <div>
       <div id="myMap" class="myMapClass" ref="myMap" v-bind:style="styleObject"></div>
    </div>
</template>
<script>
	export default {
		data() {
			return {
				styleObject: {
					height: ''
				},
				mapArr: [],
				mapScale: [
					20,
					50,
					100,
					200,
					500,
					1000,
					2000,
					5000,
					10000,
					20000,
					25000,
					50000,
					100000,
					200000,
					500000,
					1000000,
					2000000,
					5000000,
					10000000
				]
			};
		},
		mounted(){
			this.load();
		},
		methods:{
			getHeight() {
				let elmain=this.$store.state.width>this.$store.state.minwidth?40:8;
				this.styleObject.height =window.innerHeight - 80 - elmain + 'px';
			},
			initMap () {
				this.createMap() ; //创建地图
				this.setMapEvent();//设置地图事件
				this.addMapControl();//向地图添加控件
				this.addMarker();//向地图中添加marker
			},
			createMap(){
				var map = new BMap.Map(this.$refs.myMap);//在百度地图容器中创建一个地图
				var maxWay = this.getMaxWay().maxWay;
				var size = 1;
				for(var i=0;i<this.mapScale.length;i++)
				{
					var a =maxWay/this.mapScale[i];
					if(a<7)
					{
						size=19-i;
						break;
					}
				}
				if(!this.getMaxWay().maxWay)
				{
					size=15;
				}
				map.centerAndZoom(this.getPoint(),size);//设定地图的中心点和坐标并将地图显示在地图容器中
				window.map = map;//将map变量存储在全局
			},
			getMaxWay()
			{
				var maxX=0,maxY=0,minX=0,minY=0;
				var map = new BMap.Map();
				if(this.mapArr.length>0)
				{
					maxY=maxX=minX=minY=new BMap.Point(this.mapArr[0].point.split(",")[1],this.mapArr[0].point.split(",")[0]);
				}
				else
				{
					return{
						maxWay: 25000,
						maxdian: new BMap.Point(103.97384238677978,30.734417850955477),
						mindian: new BMap.Point(103.97384238677978,30.734417850955477)
					};
				}
				for(var i=1;i<this.mapArr.length;i++)
				{
					if(Number(this.mapArr[i].point.split(",")[1])>maxX.lng)
					{
						maxX=new BMap.Point(this.mapArr[i].point.split(",")[1],this.mapArr[i].point.split(",")[0]);
					}
					if(Number(this.mapArr[i].point.split(",")[0])>maxY.lat)
					{
						maxY=new BMap.Point(this.mapArr[i].point.split(",")[1],this.mapArr[i].point.split(",")[0]);
					}
					if(Number(this.mapArr[i].point.split(",")[1])<minX.lng)
					{
						minX=new BMap.Point(this.mapArr[i].point.split(",")[1],this.mapArr[i].point.split(",")[0]);
					}
					if(Number(this.mapArr[i].point.split(",")[0])<minY.lat)
					{
						minY=new BMap.Point(this.mapArr[i].point.split(",")[1],this.mapArr[i].point.split(",")[0]);
					}
				}
				var maxdian=maxX;
				var mindian=minX;
				var maxWay=Number((map.getDistance(maxX,minX)).toFixed(2));
				if(Number((map.getDistance(maxX,maxY)).toFixed(2))>maxWay)
				{
					maxWay=Number((map.getDistance(maxX,maxY)).toFixed(2));
					maxdian=maxX;
					mindian=maxY;
				}
				if(Number((map.getDistance(maxX,minY)).toFixed(2))>maxWay)
				{
					maxWay=Number((map.getDistance(maxX,minY)).toFixed(2));
					maxdian=maxX;
					mindian=minY;
				}
				if(Number((map.getDistance(minX,maxY)).toFixed(2))>maxWay)
				{
					console.log(1);
					maxWay=Number((map.getDistance(minX,maxY)).toFixed(2));
					maxdian=minX;
					mindian=maxY;
				}
				if(Number((map.getDistance(minX,minY)).toFixed(2))>maxWay)
				{
					maxWay=Number((map.getDistance(minX,minY)).toFixed(2));
					maxdian=minX;
					mindian=minY;
				}
				if(Number((map.getDistance(maxY,minY)).toFixed(2))>maxWay)
				{
					maxWay=Number((map.getDistance(maxY,minY)).toFixed(2));
					maxdian=maxY;
					mindian=minY;
				}
				return {
					maxWay: maxWay,
					maxdian: maxdian,
					mindian: mindian
				};
			},
			getPoint()
			{
				var dian=this.getMaxWay();
				return new BMap.Point((dian.maxdian.lng+dian.mindian.lng)/2,(dian.maxdian.lat+dian.mindian.lat)/2);
			},
			setMapEvent(){
				map.enableDragging();//启用地图拖拽事件，默认启用(可不写)
				map.enableScrollWheelZoom();//启用地图滚轮放大缩小
				map.enableDoubleClickZoom();//启用鼠标双击放大，默认启用(可不写)
				map.enableKeyboard();//启用键盘上下左右键移动地图
			},
			addMapControl(){
				//向地图中添加缩放控件
				var ctrl_nav = new BMap.NavigationControl({anchor:BMAP_ANCHOR_TOP_LEFT,type:BMAP_NAVIGATION_CONTROL_LARGE});
				map.addControl(ctrl_nav);
				//向地图中添加缩略图控件
				var ctrl_ove = new BMap.OverviewMapControl({anchor:BMAP_ANCHOR_BOTTOM_RIGHT,isOpen:1});
				map.addControl(ctrl_ove);
				//向地图中添加比例尺控件
				var ctrl_sca = new BMap.ScaleControl({anchor:BMAP_ANCHOR_BOTTOM_LEFT});
				map.addControl(ctrl_sca);
			},
			addMarker(){
				let _this=this
				var markerArr =_this.mapArr;
				var point = new Array();//定义数组标注经纬信息
				var marker = new Array();//定义数组点对象信息
				var info = new Array();//定义悬浮提示信息
				for(let i = 0; i < markerArr.length; i++){//遍历
					var infoA = markerArr[i].point.split(",")[1];//分割|
					var infoB = markerArr[i].point.split(",")[0];
					point[i] = new window.BMap.Point(infoA,infoB);
					marker[i] = new window.BMap.Marker(point[i]);
					map.addOverlay(marker[i]);
					//marker[i].setAnimation(BMAP_ANIMATION_BOUNCE);
					var label = new window.BMap.Label(markerArr[i].title,{offset: new window.BMap.Size(20,-10)});
					marker[i].setLabel(label);
					info[i] = new window.BMap.InfoWindow("<p style='font-size:12px;line-height:1.8em;'> 基地名：" + markerArr[i].title + "<br /> 联系人：" + markerArr[i].contact + "<br /> 电话：" + markerArr[i].tel+"<br />基地分布图：<a href='scattergram?id="+markerArr[i].id+"'>点击进入</a></p>");//悬浮提示信息
					marker[i].addEventListener("mouseover",function(){
						this.openInfoWindow(info[i]);//悬浮监听提示方法
					});
				}
			},
			load()
			{
				this.$store.commit('mainload',true);
				this.axios.get(this.config['apiurl'] + '/api/qaedas/getList', {
					params: {
						token: this.getCookie(this.config["token"])
					}
				})
				.then((response) => {
					if(response.data.code==1)
					{
						this.mapArr=response.data.data.list.map(value=>{
							return{
								id: value.id,
								title: value.name,
								point: value.latlong,
								address: value.address==""?"无":value.address,
								tel: value.mobile==""?"无":value.mobile,
								contact: value.username==""?"无":value.username
							}
						});
						this.initMap();
					}
					else if(response.data.code==0)
					{
						this.$message({
							message: response.data.msg,
							type: 'error',
							center: true,
						});
					}
					this.$store.commit('mainload',false);
				})
				.catch((response) => {
					console.log(response);
					this.errorH(error.response.status);
				})
			}
		},
		created() {
			window.addEventListener('resize', this.getHeight);
			this.getHeight()
		},
		destroyed() {
			window.removeEventListener('resize', this.getHeight)
		}
	}

</script>
<style scoped>
	.myMapClass{
		width: 100%;
		/* height: 400px; */
	}
</style>